import {TreeNode} from 'primeng/api';

export class  AdcRecord {
    id!: number;
    patientName!: string;
    patientId!: string;
    medDesc!: string;
    medId!: string;
    csn!: string;
    loc!: string;
    adminId!: string;
    serviceGroup!: string;
    var!: string;
    uom!: string;
    admin!: Date;
    transType!: string;
    resolutionCoding!: string;
    entityType: string | null = null;
    children!:any[];
    maapKey!:string;
    mrnNum!:string;
    comment!:string;
    resolution!:string;
    lanId!:string;
    employeeName!: string;
    userGrp!:string;
    adminGroup!:string;
    uniqueKey2!:string;
    discDesc!:string;
    varDateString!:string;
    medGroupName!:string;
    ScanRequired!: number;
    WasScanned!: number;
    FirstReason!: string;
    SecondReason!: string;
    ThirdReason!: string;
    FirstInstruction!: string;
    SecondInstruction!: string;
    AdminComments!: string;
    infusion_rate!: number;
    infusion_uom!: string;
    infusion_start_time!: Date;
    infusion_stop_time!: Date;

    static fromJSON(object: any)
    {
      const record = new AdcRecord();
      record.infusion_rate = object.infusion_rate
      record.infusion_uom= object.infusion_uom
      record.infusion_start_time= object.infusion_start_time
      record.infusion_stop_time = object.infusion_stop_time
      record.children = [];
      record.id=object._id;
      record.mrnNum = object.PatientID?.replace("Error","NoEHR");
      record.csn = object.csn;
      record.employeeName=object.UserName;
      record.patientName=object.PatientName;
      record.patientId=object.PatientID;
      record.lanId=object.UserID;
      record.medDesc=object.MedDescription;
      record.medId=object.MedID || "";
      record.loc=object.Device;
      record.adminId=object.UserID;
      record.var=object.Discrepancy || "";
      record.uom=object.UOM;
      record.admin= object.dateTime;
      record.transType=object.TransactionType||"";
      record.resolutionCoding="";
      record.ScanRequired = object.ScanRequired;
      record.WasScanned = object.WasScanned;
      record.FirstReason = object.FirstReason;
      record.SecondReason = object.SecondReason;
      record.ThirdReason = object.ThirdReason;
      record.FirstInstruction = object.FirstInstruction;
      record.SecondInstruction = object.SecondInstruction;
      record.AdminComments = object.AdminComments;
      record.userGrp = object.UserType;
      record.serviceGroup = object.serviceGroup;
      record.adminGroup = object.adminGroup;
      record.uniqueKey2 = object.uniqueKey2;
      if (typeof(object.varDate) != 'undefined')
      {
        record.varDateString = object.varDate.toLocaleString("en-US", {
        localeMatcher: "best fit",
        timeZoneName: "short"
      });
      }else {
        record.varDateString = object.dateTime?.toLocaleString("en-US", {
          localeMatcher: "best fit",
          timeZoneName: "short"
        });;
      }

      if(!["",null, undefined].includes(object.medGroupName))
      record.medGroupName = object.medGroupName;
      else
      record.medGroupName = object.medDesc;

        return record;
      }




    static toTreeNode(record:AdcRecord):TreeNode
    {
        return ({data:Object.assign({}, record), children:[{data:{label:"Compiled Data"},children:[{}]},{data:{label:"ADC Data"},children:[{}]},{data:{label:"EHR Data"},children:[{}]}], leaf:true, expanded:false, parent:null} as unknown) as TreeNode
    }

  }
